import { AppEnvironment } from '../../app/models/environment/app-environment.type';
import { buildConfig } from '../build/build-config';

export const environment: AppEnvironment = {
  ...buildConfig,
  name: 'scottish-power-heating',
  production: false,
  runtimeConfigPath: 'config.json',
  hasMyAccountIntegration: false,
  hasPlanSelection: false,
  hasAuthGuard: false,
  brandKey: 'scottish',
  brandConfig: {
    title: 'Scottish Power',
    logo: {
      alt: 'Scottish Power logo',
      aspectRatio: '16:1',
      src: 'assets/scottish-logo-mobile.png',
    },
    hero: {
      alt: '',
      aspectRatio: '1:1',
      src: 'assets/scottish-power-hero.jpg',
    },
    variant: 'heating',
    appliances: ['E4', 'E1'],
  },
};
